import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CHECKOUT_URL } from "../lib/constants";
import { trackPixel } from "../lib/useMetaPixel";

// Appears once the user scrolls past the hero's primary CTA.
export function FloatingCta({
  anchorId
}: {
  anchorId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById(anchorId);
    if (!anchor) return;
    if (typeof IntersectionObserver === "undefined") {
      const updateVisibility = () => setVisible(anchor.getBoundingClientRect().bottom < 0);
      updateVisibility();
      window.addEventListener("scroll", updateVisibility, {
        passive: true
      });
      return () => window.removeEventListener("scroll", updateVisibility);
    }
    const observer = new IntersectionObserver(([entry]) => {
      // Show as soon as the primary CTA has scrolled out of view (upward).
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, [anchorId]);
  return <AnimatePresence data-id="element-84" data-mp="2f5vd53n6jljp">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: "spring",
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3" data-id="element-85" data-mp="21dfd8bpks3n0">
          <a href={CHECKOUT_URL} onClick={() => trackPixel("InitiateCheckout")} className="mx-auto flex max-w-md items-center justify-center gap-2 rounded-full bg-[#a04a63] px-6 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-white shadow-2xl transition-colors hover:bg-[#8a3a52] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#c98aa0] sm:text-base" data-id="element-86" data-mp="1we2lpdnre8e3">
            ✨ Quiero lanzar mi línea · $12,99 ✨
          </a>
        </motion.div>}
    </AnimatePresence>;
}